import React, { Component } from 'react';
import AuthService from '../../AuthService';
import constants from '../../../config';
import { resolveCardImage } from '../../../utils/resolveImage';
import { formatDate, STATUS_COLORS } from './formatters';

var Auth = new AuthService();

class UserOrdersTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      pagination: { page: 1, limit: 20, total: 0, pages: 0 },
      loading: true,
    };
    this.fetchOrders = this.fetchOrders.bind(this);
  }

  componentDidMount() {
    this.fetchOrders(1);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchOrders(1);
    }
  }

  fetchOrders(page) {
    var self = this;
    self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + self.props.userId + '/orders?page=' + page + '&limit=20')
      .then(function(data) {
        self.setState({ orders: data.orders || [], pagination: data.pagination || {}, loading: false });
      })
      .catch(function(err) {
        console.log('Failed to fetch user orders:', err);
        self.setState({ loading: false });
      });
  }

  render() {
    var self = this;
    var orders = this.state.orders;
    var pagination = this.state.pagination;

    if (this.state.loading) {
      return (
        <div className="tw-text-center tw-py-8">
          <i className="fa fa-circle-o-notch fa-spin tw-text-xl tw-mb-2" style={{ color: '#D4A843', display: 'block' }} />
          <span className="tw-text-xs tw-text-[#999]">Loading orders...</span>
        </div>
      );
    }

    if (orders.length === 0) {
      return (
        <div className="tw-text-center tw-py-8">
          <i className="fa fa-exchange tw-text-2xl tw-mb-2" style={{ color: '#ccc', display: 'block' }} />
          <p className="tw-text-sm tw-text-[#999] tw-m-0">No orders found</p>
        </div>
      );
    }

    return (
      <div>
        <div className="tw-space-y-3">
          {orders.map(function(order) {
            var isBuyer = order.buyer && order.buyer._id === self.props.userId;
            var roleLabel = isBuyer ? 'Buyer' : 'Seller';
            var roleColor = isBuyer ? '#3B82F6' : '#10B981';
            var statusColor = STATUS_COLORS[order.payoutStatus] || STATUS_COLORS[order.status] || '#6B7280';
            var statusLabel = order.payoutStatus || order.status || 'unknown';
            var post = order.post || {};
            var otherUser = isBuyer ? order.seller : order.buyer;

            return (
              <div key={order._id} className="tw-p-3 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                <div className="tw-flex tw-items-start tw-gap-3">
                  {(resolveCardImage(post.cardImage) || (post.images && post.images[0] && resolveCardImage(post.images[0]))) ? (
                    <img src={resolveCardImage(post.cardImage) || resolveCardImage(post.images[0])} alt="" className="tw-w-10 tw-h-10 tw-rounded-lg tw-object-cover tw-flex-shrink-0" />
                  ) : (
                    <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                      <i className="fa fa-image tw-text-[#ccc]" />
                    </div>
                  )}
                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-truncate">{post.title || 'Deleted listing'}</div>
                    <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-flex-wrap">
                      <span className="tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium tw-text-white" style={{ backgroundColor: roleColor }}>{roleLabel}</span>
                      <span className="tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded-full tw-font-medium" style={{ backgroundColor: statusColor + '20', color: statusColor }}>{statusLabel}</span>
                      {otherUser && (
                        <span className="tw-text-xs tw-text-[#999]">
                          {isBuyer ? 'from ' : 'to '}{otherUser.userName || 'Unknown'}
                        </span>
                      )}
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-3 tw-mt-1.5 tw-text-xs tw-text-[#999]">
                      <span>${(post.price || order.total || 0).toFixed(2)}</span>
                      <span>{order.createdAt ? formatDate(order.createdAt) : ''}</span>
                      {order.paymentMethod && (
                        <span className="tw-capitalize">{order.paymentMethod}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {pagination.pages > 1 && (
          <div className="tw-flex tw-justify-between tw-items-center tw-mt-4 tw-pt-3 tw-border-t tw-border-[#eee] dark:tw-border-[#222]">
            <span className="tw-text-xs tw-text-[#999]">{pagination.total} total</span>
            <div className="tw-flex tw-gap-1">
              <button
                className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                disabled={pagination.page <= 1}
                onClick={function() { self.fetchOrders(pagination.page - 1); }}
              >Prev</button>
              <button
                className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                disabled={pagination.page >= pagination.pages}
                onClick={function() { self.fetchOrders(pagination.page + 1); }}
              >Next</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UserOrdersTab;
